//import { ConsolePage } from './pages/ConsolePage';
import Login from './Login';
import './App.scss';
import { Routes, Route } from 'react-router-dom';
import { ConsolePage } from './pages/ConsolePage';
import PrivateRoute from './pages/PrivateRouting';
import { useEffect } from 'react';

function App() {
  return (
    <div data-component="App">
      {/* <ConsolePage /> */}
      {/* <Login/> */}
      
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/console" element={<ConsolePage />} />
      </Routes>
   
    </div>
  );
}

export default App;
